import React from "react";
import { Helmet } from "react-helmet-async";

import SignIn from "../../components/auth/SignIn";
import SabahLogo from "../../assets/img/photos/sabah-logo.png";

const SignInPage = () => (
  <React.Fragment>
    <Helmet title='Log Masuk' />
    <div className='d-flex flex-column'>
      <div className='text-center mb-4'>
        <img
          src={SabahLogo}
          alt='Jata Negeri Sabah'
          style={{ height: "auto", width: 72 }}
        />
        <div
          className='fw-bold text-primary mt-2'
          style={{ letterSpacing: "0.12em" }}
        >
          SMEPPS
        </div>
      </div>
      <SignIn />
      <div className='mt-4 pt-3 border-top text-center text-muted small'>
        &copy; {new Date().getFullYear()}
        <span className='ms-1'>Kerajaan Negeri Sabah</span>
      </div>
    </div>
  </React.Fragment>
);

export default SignInPage;
